import { createAction, props } from "@ngrx/store";
import { MtmaUploadResponseData } from "src/app/model/api/data-rest";
import { MtmaUploadData } from "src/app/model/mtma-import-export-file";


//---------- MTMA IMPORT LIST CSV
export const resetMtmaImportCsv = createAction('RESET_MTMA_IMPORT_LIST_CSV');
export const postMtmaImportCsv = createAction('POST_MTMA_IMPORT_LIST_CSV', props<{ deviceId: number; mtmaUploadData: MtmaUploadData }>());
export const postMtmaImportCsvSuccess = createAction('POST_MTMA_IMPORT_LIST_CSV_SUCCESS', props<{ message: string; mtmaUploadResponseData: MtmaUploadResponseData }>());
export const postMtmaImportCsvFailed = createAction('POST_MTMA_IMPORT_LIST_CSV_FAILED', props<{ errorMessage: string; mtmaUploadResponseData: MtmaUploadResponseData }>());
//---------- MTMA IMPORT LIST CSV